export type UploadFileType = {
  contentType: string
  extensions: readonly string[]
  label: string
  scan: boolean
  readable: boolean
}

export const UPLOAD_FILE_TYPES: readonly UploadFileType[] = [
  {
    contentType: 'application/pdf',
    extensions: ['pdf'],
    label: 'PDF',
    scan: true,
    readable: true
  },
  {
    contentType: 'image/jpeg',
    extensions: ['jpg', 'jpeg'],
    label: 'JPEG',
    scan: true,
    readable: true
  },
  {
    contentType: 'image/png',
    extensions: ['png'],
    label: 'PNG',
    scan: true,
    readable: true
  },
  {
    contentType: 'image/gif',
    extensions: ['gif'],
    label: 'GIF',
    scan: true,
    readable: true
  },
  {
    contentType: 'image/webp',
    extensions: ['webp'],
    label: 'WebP',
    scan: true,
    readable: true
  },
  {
    contentType: 'image/tiff',
    extensions: ['tif', 'tiff'],
    label: 'TIFF',
    scan: true,
    readable: false
  },
  {
    contentType: 'image/heic',
    extensions: ['heic', 'heif'],
    label: 'HEIC',
    scan: true,
    readable: false
  },
  {
    contentType: 'text/csv',
    extensions: ['csv'],
    label: 'CSV',
    scan: false,
    readable: false
  },
  {
    contentType: 'text/plain',
    extensions: ['txt'],
    label: 'TXT',
    scan: false,
    readable: false
  },
  {
    contentType: 'application/vnd.ms-excel',
    extensions: ['xls'],
    label: 'XLS',
    scan: false,
    readable: false
  },
  {
    contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    extensions: ['xlsx'],
    label: 'XLSX',
    scan: false,
    readable: false
  },
  {
    contentType: 'application/msword',
    extensions: ['doc'],
    label: 'DOC',
    scan: false,
    readable: false
  },
  {
    contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    extensions: ['docx'],
    label: 'DOCX',
    scan: false,
    readable: false
  }
]
